module.exports = __webpack_public_path__ + "static/media/nouvelr-regular.4687a9cf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/nouvelr/nouvelr-regular.woff2
// module id = 937
// module chunks = 0